import React, { useEffect, useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import api from '../lib/api';
import { toast } from 'sonner';
import { Users, Target } from 'lucide-react';

const STATUS_COLORS = {
  Aktiv: 'bg-green-100 text-green-700',
  Inväntar_beslut: 'bg-yellow-100 text-yellow-700',
  Pausad: 'bg-gray-100 text-gray-700',
  Avslutad: 'bg-blue-100 text-blue-700',
};

const AssignerDashboard = () => {
  const [participants, setParticipants] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/me/assignor-overview')
      .then(r => setParticipants(r.data?.participants || []))
      .catch(() => toast.error('Kunde inte hämta dina deltagare'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <DashboardLayout>
        <div className="min-h-[60vh] flex items-center justify-center">
          <p className="text-muted-foreground">Laddar...</p>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6 max-w-5xl" data-testid="assigner-dashboard">
        <div>
          <h1 className="text-4xl font-heading font-black tracking-tight flex items-center gap-3">
            <Users className="text-primary" size={36} />
            Mina deltagare
          </h1>
          <p className="text-muted-foreground mt-2">
            Översikt av deltagare du har behörighet att följa.
          </p>
        </div>

        {participants && participants.length === 0 ? (
          <Card>
            <CardContent className="p-10 text-center">
              <Users size={48} className="mx-auto mb-4 text-muted-foreground" />
              <p className="text-muted-foreground">
                Ditt konto är inte kopplat till några deltagare. Kontakta din administratör.
              </p>
            </CardContent>
          </Card>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {participants.map(p => {
              const statusColor = STATUS_COLORS[p.status] || 'bg-gray-100 text-gray-700';
              return (
                <Card key={p.id} data-testid={`assigner-participant-${p.id}`}>
                  <CardHeader className="pb-2">
                    <CardTitle className="font-heading font-bold text-base">{p.name}</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-3">
                    <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-bold ${statusColor}`}>
                      {p.status}
                    </span>
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <Target size={16} />
                      <span>{p.active_goals_count} aktiva mål</span>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default AssignerDashboard;
